
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/[groupSlug]",
      function () {
        return require("private-next-pages/groups/[groupSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups/[groupSlug]"])
      });
    }
  